import axiosInstance from '../../services/axios';
import { applyFilters, getAPIEndpoint } from '../../helpers'


export default {
    namespaced: true,
    state: {
        items: [],
        total: 0
    },
    getters: {


    },
    actions: {
        fetchUsers({ state, commit }, { filter = {} }) {
            const url = applyFilters(`${getAPIEndpoint()}/users`, filter)

            return axiosInstance.get(url).then(res => {

                const userArray = res.data.data

                const total = res.data.total ?? 0

                commit('loadUsers', userArray)
                commit('loadTotalUser', total)


            })
        },
        createUser({ commit }, formData) {
            return axiosInstance.post(`${getAPIEndpoint()}/users`, formData)
                .then(res => {
                    const createdUser = res.data.data.data
                    commit('addUser', createdUser)

                })
        },
        deleteUserWithId({ commit, state }, id) {
            return axiosInstance.delete(`${getAPIEndpoint()}/users/${id}`)
                .then(() => {
                    const updatedItems = [...state.items].filter(user => user._id !== id);

                    commit('deleteUser', updatedItems)
                });
        },
        updateUser({ commit, state }, formData) {

            return axiosInstance.patch(`${getAPIEndpoint()}/users/${formData._id}`, formData)
                .then(res => {
                    const updatedUser = res.data.data.data
                    const updatedItems = [...state.items].filter(user => user._id !== formData._id);
                    updatedItems.unshift(updatedUser);
                    commit('updateUser', updatedItems)
                })
        },



    },
    mutations: {
        loadUsers(state, users) {
            return state.items = users
        },
        addUser(state, user) {
            return state.items.unshift(user);
        },
        deleteUser(state, updatedItems) {

            return state.items = updatedItems
        },
        updateUser(state, updatedItems) {
            return state.items = updatedItems
        },
        loadTotalUser(state, totalUserNumber) {
            return state.total = totalUserNumber
        }

    }
}